const TESTIMONIALS = [
  {
    logo: "Verde Spa",
    quote:
      "Our weekend bookings doubled within ten days. Lychee sent us creators who actually understood wellness — they shot in our space, our way.",
    name: "Layla Haddad",
    role: "Founder, Verde Spa · Dubai",
    avatar:
      "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=200&q=80&auto=format&fit=crop",
  },
  {
    logo: "Casa Solé",
    quote:
      "We used to chase agencies and influencers in DMs for months. Lychee delivered a confirmed 3-creator visit in 6 days. Walk-ins are up 40%.",
    name: "Omar Khalil",
    role: "Owner, Casa Solé · Riyadh",
    avatar:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&q=80&auto=format&fit=crop",
  },
  {
    logo: "Lumina Clinic",
    quote:
      "The before/after content alone drove a 5× lift in consultation requests. The team handles briefs, scheduling, deliverables — we just see results.",
    name: "Dr. Reem Al-Sayed",
    role: "Medical director, Lumina Clinic · Doha",
    avatar:
      "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=200&q=80&auto=format&fit=crop",
  },
];

export default function Testimonials() {
  return (
    <section
      id="customers"
      data-testid="testimonials-section"
      className="py-24 sm:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl mb-14">
          <p className="text-xs uppercase tracking-[0.22em] text-[#276152] font-semibold">
            Customer stories
          </p>
          <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl mt-5 tracking-[-0.03em] text-[#0D3A35] font-semibold leading-[0.95]">
            Local brands run on{" "}
            <span className="text-[#276152]">Lychee.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-4">
          {TESTIMONIALS.map((t, i) => (
            <article
              key={t.name}
              data-testid={`testimonial-card-${i}`}
              className="bg-[#F6F5F1] rounded-2xl p-8 flex flex-col min-h-[340px] border border-[#B1B7AB]/30"
            >
              <p className="font-display text-xl tracking-[-0.01em] text-[#0D3A35] font-semibold">
                {t.logo}
              </p>

              <blockquote className="mt-6 text-[15px] leading-relaxed text-[#0D3A35]/90 flex-1">
                &ldquo;{t.quote}&rdquo;
              </blockquote>

              <div className="mt-8 flex items-center gap-3 pt-6 border-t border-[#B1B7AB]/40">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover border border-[#B1B7AB]/60"
                />
                <div>
                  <p className="text-sm font-semibold text-[#0D3A35]">
                    {t.name}
                  </p>
                  <p className="text-xs text-[#276152]">{t.role}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
